import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "../HOC/withRouter";
import {
  mapStatetoProps,
  mapSetActiveMenuToProps,
} from "../mapRedux/mapReduxProps";
import { Box, Grid } from "@mui/material";
import CtBtn from "./CustomTool/CtBtn";
import CtDtp from "./CustomTool/CtDtp";
import TableList from "./CustomTool/TableList";

class JobInList extends Component {
  state = {
    CompanyName: [],
    Customer: [],
    rows: [],
    columns: [
      { id: "Action", label: "Search", name: "Search" },
      { id: "companyname", label: "Company Name" },
      { id: "jobinsrno", label: "Job In Sr. No." },
      { id: "jobindate", label: "Job In Date" },
      { id: "customer", label: "Customer" },
      { id: "disamt", label: "Dis Amt" },
      { id: "taxable", label: "Taxable" },
      { id: "cgst", label: "CGST" },
      { id: "sgst", label: "SGST" },
      { id: "igst", label: "IGST" },
      { id: "totalamount", label: "Total Amount" },
    ],
    searchData: {
      companyname: "",
      jobinsrno: "",
      jobindate: "",
      customer: "",
      disamt: "",
      taxable: "",
      cgst: "",
      sgst: "",
      igst: "",
      totalamount: "",
    },
    searchColumns: [],
    searchRows: [],
    searchOpen: false,
    searchRowsCount: 0,
  };

  //#region Component
  componentDidMount() {
    document.title = "RA : Job In List";
    this.props.setActiveMenu("JobInList");
    this.setSearchColumns();
  }
  //#endregion Component

  //#region Handle
  handleOnSearchChange = (searchOpen) => {
    let searchRows = [];
    if (searchOpen === true && this.state.rows.length > 0) {
      this.state.rows.map((row) => {
        if (
          searchOpen === true &&
          (this.state.searchData.companyname === "ALL" ||
            this.state.searchData.companyname === row["companyname"]) &&
          (this.state.searchData.jobinsrno.length === 0 ||
            (row["jobinsrno"] &&
              row["jobinsrno"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.jobinsrno.toLowerCase()))) &&
          (this.state.searchData.jobindate.length === 0 ||
            (row["jobindate"] &&
              row["jobindate"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.jobindate.toLowerCase()))) &&
          (this.state.searchData.customer === "ALL" ||
            this.state.searchData.customer === row["customer"]) &&
          (this.state.searchData.disamt.length === 0 ||
            (row["disamt"] &&
              row["disamt"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.disamt.toLowerCase()))) &&
          (this.state.searchData.taxable.length === 0 ||
            (row["taxable"] &&
              row["taxable"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.taxable.toLowerCase()))) &&
          (this.state.searchData.cgst.length === 0 ||
            (row["cgst"] &&
              row["cgst"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.cgst.toLowerCase()))) &&
          (this.state.searchData.sgst.length === 0 ||
            (row["sgst"] &&
              row["sgst"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.sgst.toLowerCase()))) &&
          (this.state.searchData.igst.length === 0 ||
            (row["igst"] &&
              row["igst"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.igst.toLowerCase()))) &&
          (this.state.searchData.totalamount.length === 0 ||
            (row["totalamount"] &&
              row["totalamount"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.totalamount.toLowerCase())))
        ) {
          searchRows.push(row);
        }
      });
      const searchRowsCount = searchRows.length;
      this.setState(
        {
          searchOpen,
          searchRows,
          searchRowsCount,
          counter: this.state.counter + 1,
        },
        () => {}
      );
    } else {
      this.setState({ searchOpen });
    }
  };
  handleOnSearchInputChange = (e) => {
    this.setState(
      {
        searchData: {
          ...this.state.searchData,
          [e.target.name]: e.target.value,
        },
      },
      () => {
        this.handleOnSearchChange(this.state.searchOpen);
        // console.log(this.state.searchData)
      }
    );
  };
  //#endregion Handle

  //#region function
  navigateTo = (link) => {
    this.props.navigate("/" + link);
  };
  handleOnNewEntryClick = () => {
    {
      this.navigateTo("JobInEntry");
    }
  };
  setSearchColumns = () => {
    let searchColumns = [];
    searchColumns.push(
      {
        cType: "CtTxt",
        id: "companyname",
        items: this.state.CompanyName,
        label: "Company Name",
        value: this.state.searchData.companyname,
        handleOnChange: this.handleOnSearchInputChange,
        width: "150",
      },
      {
        cType: "CtTxt",
        id: "jobinsrno",
        label: "Job In Sr. No.",
        value: this.state.searchData.jobinsrno,
        handleOnChange: this.handleOnSearchInputChange,
        width: "150",
        maxLength: "100",
      },
      {
        cType: "CtTxt",
        label: "Job In Date",
        width: "120",
      },
      {
        cType: "CtTxt",
        id: "customer",
        items: this.state.Customer,
        label: "Customer",
        value: this.state.searchData.customer,
        handleOnChange: this.handleOnSearchInputChange,
        width: "150",
      },
      {
        cType: "CtTxt",
        id: "disamt",
        label: "Dis Amt",
        value: this.state.searchData.disamt,
        handleOnChange: this.handleOnSearchInputChange,
        width: "150",
      },
      {
        cType: "CtTxt",
        id: "taxable",
        label: "Taxable",
        value: this.state.searchData.taxable,
        handleOnChange: this.handleOnSearchInputChange,
        width: "150",
      },
      {
        cType: "CtTxt",
        id: "cgst",
        label: "CGST",
        value: this.state.searchData.cgst,
        handleOnChange: this.handleOnSearchInputChange,
        width: "150",
      },
      {
        cType: "CtTxt",
        id: "sgst",
        label: "SGST",
        value: this.state.searchData.sgst,
        handleOnChange: this.handleOnSearchInputChange,
        width: "150",
      },
      {
        cType: "CtTxt",
        id: "igst",
        label: "IGST",
        value: this.state.searchData.igst,
        handleOnChange: this.handleOnSearchInputChange,
        width: "150",
      },
      {
        cType: "CtTxt",
        id: "totalamount",
        label: "Total Amount",
        value: this.state.searchData.totalamount,
        handleOnChange: this.handleOnSearchInputChange,
        width: "150",
      }
    );
    this.setState({ searchColumns });
  };

  //#endregion function

  render() {
    return (
      <div>
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          className="title"
        >
          <label htmlFor="Title" style={{ fontSize: "30px", color: "#515151" }}>
            <b>Job In List</b>
          </label>
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          spacing={0}
          marginTop={0}
        >
          <Grid item>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              spacing={2}
              marginTop={0}
            >
              <Grid item>
                <CtDtp
                  id="dtpFromDate"
                  label="From Date"
                  width="150"
                  // disabled={this.state.disabledProfileData.DOBDS}
                />
              </Grid>
              <Grid item>
                <CtDtp
                  id="dtpToDate"
                  label="To Date"
                  width="150"
                  // disabled={this.state.disabledProfileData.DOBDS}
                />
              </Grid>
              <Grid item>
                <CtBtn label="Load" />
              </Grid>
              <Grid item>
                <CtBtn label="Print" />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <br />
        <TableList
          columns={this.state.columns}
          counter={this.state.counter}
          rows={this.state.rows}
          // rowsCount={rowsCount}
          headRowFontColor="#ffffff"
          // rowsPerPage={this.state.rowsPerPage}
          // handleChangeRowsPerPage={this.handleChangeRowsPerPage}
          // handleOnActionClick={this.handleARDonActionClick}
          // actionList={this.state.actionList}
          // keyColumn={this.state.keyColumn}
          handleOnSearchChange={this.handleOnSearchChange}
          searchColumns={this.state.searchColumns}
          searchData={this.state.searchData}
          provideSearch={true}
          handleOnNewEntryClick={this.handleOnNewEntryClick}
          toolTipNewEntry="Job In Entry"
        />
        {/* <Grid item>
          <Box display={{ xs: "none" }} style={{ textAlign: "right" }}>
            {this.state.ARD}
          </Box>
        </Grid> */}
      </div>
    );
  }
}

export default connect(
  mapStatetoProps,
  mapSetActiveMenuToProps
)(withRouter(JobInList));
